import { VerificationTransactionSummary } from "@idw-types/data/reports";
import { isNullOrUndefined } from "@utils/object-util";
import { CardContainer } from "../../../common/card-container/card-container";
import { VerificationTransactionsSummaryPieChart } from "../verification-transactions-summary-pie-chart/verification-transactions-summary-pie-chart";
import styles from "./verification-transactions-summary-container.less";

type VerificationTransactionsSummaryContainerProps = {
    verificationTransactionSummary: VerificationTransactionSummary;
};

export const VerificationTransactionsSummaryContainer = (props: VerificationTransactionsSummaryContainerProps) => {
    const { verificationTransactionSummary } = props;
    const idPrefix = 'verification-transactions-summary';
    return (
        <div className={styles.verificationTransactionsSummaryContainer}>
            <CardContainer className={styles.summaryCard}>
                    <span className={styles.summaryTitle}>Verification Results</span>
                    <VerificationTransactionsSummaryPieChart data={verificationTransactionSummary} />
            </CardContainer>
            {!isNullOrUndefined(verificationTransactionSummary.transactionCount) && (
                <CardContainer className={styles.summaryCard}>
                        <span id={`${idPrefix}-transaction-count`} className={styles.summaryData}>{verificationTransactionSummary.transactionCount}</span>
                        <span className={styles.summaryTitle}>Total transactions</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(verificationTransactionSummary.averageScore) && (
                <CardContainer className={styles.summaryCard}>
                        <span id={`${idPrefix}-average-score`} className={styles.summaryData}>{verificationTransactionSummary.averageScore}</span>
                        <span className={styles.summaryTitle}>Average Trust Score</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(verificationTransactionSummary.policyApprovalCount) && (
                <CardContainer className={styles.summaryCard}>
                        <span id={`${idPrefix}-policy-approval-count`} className={styles.summaryData}>{verificationTransactionSummary.policyApprovalCount}</span>
                        <span className={styles.summaryTitle}>Verified Users</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(verificationTransactionSummary.policyRejectionCount) && (
                <CardContainer className={styles.summaryCard}>
                        <span id={`${idPrefix}-policy-rejection-count`} className={styles.summaryData}>{verificationTransactionSummary.policyRejectionCount}</span>
                        <span className={styles.summaryTitle}>Risky Transactions Blocked</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(verificationTransactionSummary.policyObligationCount) && (
                <CardContainer className={styles.summaryCard}>
                        <span id={`${idPrefix}-policy-obligation-count`} className={styles.summaryData}>{verificationTransactionSummary.policyObligationCount}</span>
                        <span className={styles.summaryTitle}>Obligations</span>
                </CardContainer>
            )}
        </div>
    )
};